<template>
  <SwitchField
      name="新規登録者のみ"
      :value="value"
      hide-details
      @input="handleInput"
  />
</template>

<script>
import SwitchField from "@/components/atoms/SwitchField";
export default {
  name: "ApplicantSearchNewcomerSelect",
  components: {SwitchField},
  props: {
    value: {
      type: Boolean
    }
  },
  methods: {
    handleInput(value) {
      this.$emit('input', value)
    }
  },
}
</script>

<style scoped>

</style>